import AbstractPerson from './AbstractPerson'
import Organisationseinheit from './Organisationseinheit'
import Patent from './Patent'
import Person from './Person'
import Forschungsprojekt from './Forschungsprojekt'
import Kooperation from './Kooperation'
import Land from './Land'
import Preis from './Preis'
import Publikation from './Publikation'
import Veranstaltung from './Veranstaltung'
import ExterneOrganisation from './ExterneOrganisation'
import AppUser from './AppUser'
import Mittelgeber from './Mittelgeber'

export default (user) => {
  let activities = [
    Forschungsprojekt,
    Publikation,
    Preis,
    Kooperation,
    Veranstaltung
  ]

  let masterdata = []

  let administration = []

  let editable = [
    AbstractPerson
  ]

  if (user.roles.TRANSFER || user.roles.ADMIN) {
    activities.push(Patent)
  }

  if (user.roles.ADMIN) {
    masterdata.push(Organisationseinheit)
    masterdata.push(Person)
    masterdata.push(AbstractPerson)
    masterdata.push(ExterneOrganisation)
    masterdata.push(Land)
    masterdata.push(Mittelgeber)
    administration.push(AppUser)
  }

  return [
    {
      label: 'Forschungsaktivitäten',
      entities: activities
    },
    {
      label: 'Stammdaten',
      entities: masterdata
    },
    {
      label: 'Administration',
      entities: administration
    },
    {
      label: '__editable',
      entities: editable
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Selection.js